import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { TranslateService } from "@ngx-translate/core";
import { Observable } from 'rxjs';
import { LocalizationService } from "../localization.service";

@Injectable({ providedIn: 'root' })
export class ScrollGuard implements CanActivate {
  constructor(@Inject(LOCALE_ID) public locale: string,
    private translate: TranslateService,
    private localizationService: LocalizationService) {
  }

  canActivate(route: any, state: any): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    return true;
  }
}
